/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from './API';
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const changePassword =
  /* GraphQL */ `mutation ChangePassword($input: ChangePasswordData!) {
  changePassword(input: $input)
}
` as GeneratedMutation<
    APITypes.ChangePasswordMutationVariables,
    APITypes.ChangePasswordMutation
  >;
export const createUser =
  /* GraphQL */ `mutation CreateUser($input: UserCreationData!) {
  createUser(input: $input) {
    Username
    UserCreateDate
    UserLastModifiedDate
    Enabled
    Status
    ContactID
    Email
    Role
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateUserMutationVariables,
    APITypes.CreateUserMutation
  >;
export const resendUser =
  /* GraphQL */ `mutation ResendUser($input: UserCreationData!) {
  resendUser(input: $input) {
    Username
    UserCreateDate
    UserLastModifiedDate
    Enabled
    Status
    ContactID
    Email
    Role
    __typename
  }
}
` as GeneratedMutation<
    APITypes.ResendUserMutationVariables,
    APITypes.ResendUserMutation
  >;
export const createAdviserUser =
  /* GraphQL */ `mutation CreateAdviserUser($input: UserAdviserCreationData!) {
  createAdviserUser(input: $input) {
    Username
    UserCreateDate
    UserLastModifiedDate
    Enabled
    Status
    ProfessionalContactID
    Email
    Role
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateAdviserUserMutationVariables,
    APITypes.CreateAdviserUserMutation
  >;
export const resendAdviserUser =
  /* GraphQL */ `mutation ResendAdviserUser($input: UserAdviserCreationData!) {
  resendAdviserUser(input: $input) {
    Username
    UserCreateDate
    UserLastModifiedDate
    Enabled
    Status
    ProfessionalContactID
    Email
    Role
    __typename
  }
}
` as GeneratedMutation<
    APITypes.ResendAdviserUserMutationVariables,
    APITypes.ResendAdviserUserMutation
  >;
export const updateEmail =
  /* GraphQL */ `mutation UpdateEmail($input: UpdateEmailData!) {
  updateEmail(input: $input)
}
` as GeneratedMutation<
    APITypes.UpdateEmailMutationVariables,
    APITypes.UpdateEmailMutation
  >;
export const adminChangeUserPassword =
  /* GraphQL */ `mutation AdminChangeUserPassword($input: UpdateAdminUserPasswordData!) {
  adminChangeUserPassword(input: $input)
}
` as GeneratedMutation<
    APITypes.AdminChangeUserPasswordMutationVariables,
    APITypes.AdminChangeUserPasswordMutation
  >;
export const signDocument = /* GraphQL */ `mutation SignDocument(
  $input: SignDocumentInput
  $ContactID: String
  $resourceId: String
) {
  signDocument(input: $input, ContactID: $ContactID, resourceId: $resourceId) {
    url
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SignDocumentMutationVariables,
  APITypes.SignDocumentMutation
>;
export const registerDevice =
  /* GraphQL */ `mutation RegisterDevice($DeviceID: String!) {
  registerDevice(DeviceID: $DeviceID)
}
` as GeneratedMutation<
    APITypes.RegisterDeviceMutationVariables,
    APITypes.RegisterDeviceMutation
  >;
export const markFormsAsReminded =
  /* GraphQL */ `mutation MarkFormsAsReminded($id: ID) {
  markFormsAsReminded(id: $id)
}
` as GeneratedMutation<
    APITypes.MarkFormsAsRemindedMutationVariables,
    APITypes.MarkFormsAsRemindedMutation
  >;
export const markRedirectsAsReminded =
  /* GraphQL */ `mutation MarkRedirectsAsReminded($ContactID: String!) {
  markRedirectsAsReminded(ContactID: $ContactID)
}
` as GeneratedMutation<
    APITypes.MarkRedirectsAsRemindedMutationVariables,
    APITypes.MarkRedirectsAsRemindedMutation
  >;
export const markApprovalDocsAsReminded =
  /* GraphQL */ `mutation MarkApprovalDocsAsReminded($ContactID: String!) {
  markApprovalDocsAsReminded(ContactID: $ContactID)
}
` as GeneratedMutation<
    APITypes.MarkApprovalDocsAsRemindedMutationVariables,
    APITypes.MarkApprovalDocsAsRemindedMutation
  >;
export const createSignatureForContact =
  /* GraphQL */ `mutation CreateSignatureForContact(
  $ContactID: String!
  $Signature: String!
  $ResourceId: String
) {
  createSignatureForContact(
    ContactID: $ContactID
    Signature: $Signature
    ResourceId: $ResourceId
  )
}
` as GeneratedMutation<
    APITypes.CreateSignatureForContactMutationVariables,
    APITypes.CreateSignatureForContactMutation
  >;
export const setMaintenanceMode =
  /* GraphQL */ `mutation SetMaintenanceMode($Mode: String!, $Message: String!) {
  setMaintenanceMode(Mode: $Mode, Message: $Message) {
    Mode
    Message
    __typename
  }
}
` as GeneratedMutation<
    APITypes.SetMaintenanceModeMutationVariables,
    APITypes.SetMaintenanceModeMutation
  >;
export const setPortalAlert =
  /* GraphQL */ `mutation SetPortalAlert($Mode: String!, $Message: String!) {
  setPortalAlert(Mode: $Mode, Message: $Message) {
    Mode
    Message
    __typename
  }
}
` as GeneratedMutation<
    APITypes.SetPortalAlertMutationVariables,
    APITypes.SetPortalAlertMutation
  >;
export const setDataIssueMaintenanceMode =
  /* GraphQL */ `mutation SetDataIssueMaintenanceMode($Message: String!) {
  setDataIssueMaintenanceMode(Message: $Message) {
    Message
    __typename
  }
}
` as GeneratedMutation<
    APITypes.SetDataIssueMaintenanceModeMutationVariables,
    APITypes.SetDataIssueMaintenanceModeMutation
  >;
export const createClientDocumentRead =
  /* GraphQL */ `mutation CreateClientDocumentRead($input: ClientDocumentReadInput!) {
  createClientDocumentRead(input: $input)
}
` as GeneratedMutation<
    APITypes.CreateClientDocumentReadMutationVariables,
    APITypes.CreateClientDocumentReadMutation
  >;
export const createAdviserDocumentRead =
  /* GraphQL */ `mutation CreateAdviserDocumentRead($input: AdviserDocumentReadInput!) {
  createAdviserDocumentRead(input: $input)
}
` as GeneratedMutation<
    APITypes.CreateAdviserDocumentReadMutationVariables,
    APITypes.CreateAdviserDocumentReadMutation
  >;
export const disableUserMfa =
  /* GraphQL */ `mutation DisableUserMfa($input: DisableUserMfa!) {
  disableUserMfa(input: $input)
}
` as GeneratedMutation<
    APITypes.DisableUserMfaMutationVariables,
    APITypes.DisableUserMfaMutation
  >;
export const createAdhoc2FACode =
  /* GraphQL */ `mutation CreateAdhoc2FACode($ResourceID: String!) {
  createAdhoc2FACode(ResourceID: $ResourceID) {
    id
    __typename
  }
}
` as GeneratedMutation<
    APITypes.CreateAdhoc2FACodeMutationVariables,
    APITypes.CreateAdhoc2FACodeMutation
  >;
export const calculateRisk = /* GraphQL */ `mutation CalculateRisk(
  $ContactID: String
  $responses: [RiskResponse]
  $resourceId: String
) {
  calculateRisk(
    ContactID: $ContactID
    responses: $responses
    resourceId: $resourceId
  ) {
    rating
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CalculateRiskMutationVariables,
  APITypes.CalculateRiskMutation
>;
export const createWithdrawal =
  /* GraphQL */ `mutation CreateWithdrawal($input: CreateWithdrawalInput!) {
  createWithdrawal(input: $input)
}
` as GeneratedMutation<
    APITypes.CreateWithdrawalMutationVariables,
    APITypes.CreateWithdrawalMutation
  >;
export const attemptWithdrawal =
  /* GraphQL */ `mutation AttemptWithdrawal($input: AttemptWithdrawalInput!) {
  attemptWithdrawal(input: $input) {
    result
    __typename
  }
}
` as GeneratedMutation<
    APITypes.AttemptWithdrawalMutationVariables,
    APITypes.AttemptWithdrawalMutation
  >;
export const setClientWithdrawalsAllow =
  /* GraphQL */ `mutation SetClientWithdrawalsAllow(
  $ContactID: String
  $input: ClientWithdrawalAllowInput!
) {
  setClientWithdrawalsAllow(ContactID: $ContactID, input: $input) {
    items {
      withdrawalMode
      spouseWithdrawalMode
      createdBy
      createdAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
    APITypes.SetClientWithdrawalsAllowMutationVariables,
    APITypes.SetClientWithdrawalsAllowMutation
  >;
export const declineInvitation =
  /* GraphQL */ `mutation DeclineInvitation($id: ID!) {
  declineInvitation(id: $id) {
    id
    link
    __typename
  }
}
` as GeneratedMutation<
    APITypes.DeclineInvitationMutationVariables,
    APITypes.DeclineInvitationMutation
  >;
export const generateCognitoUserExportRequest =
  /* GraphQL */ `mutation GenerateCognitoUserExportRequest($ID: ID!) {
  generateCognitoUserExportRequest(ID: $ID) {
    ID
    Status
    __typename
  }
}
` as GeneratedMutation<
    APITypes.GenerateCognitoUserExportRequestMutationVariables,
    APITypes.GenerateCognitoUserExportRequestMutation
  >;
export const publishCognitoUserExport =
  /* GraphQL */ `mutation PublishCognitoUserExport($result: CognitoUserExportInput) {
  publishCognitoUserExport(result: $result) {
    ID
    Status
    url
    __typename
  }
}
` as GeneratedMutation<
    APITypes.PublishCognitoUserExportMutationVariables,
    APITypes.PublishCognitoUserExportMutation
  >;
export const createNotification = /* GraphQL */ `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    ContactID
    Message
    LinkUrl
    LinkText
    LinkRedirectCommand
    LinkActionApprovalDocID
    IsRead
    IsClicked
    ShowToast
    SendEmail
    EmailSubject
    EmailMessage
    disabled
    expireAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    ContactID
    Message
    LinkUrl
    LinkText
    LinkRedirectCommand
    LinkActionApprovalDocID
    IsRead
    IsClicked
    ShowToast
    SendEmail
    EmailSubject
    EmailMessage
    disabled
    expireAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const deleteNotification = /* GraphQL */ `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    ContactID
    Message
    LinkUrl
    LinkText
    LinkRedirectCommand
    LinkActionApprovalDocID
    IsRead
    IsClicked
    ShowToast
    SendEmail
    EmailSubject
    EmailMessage
    disabled
    expireAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
